import sample_1 from './sample1.jpeg';

export const dynamicIndustryImageKfzImpressions = {
    sample_1,
};
